import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const assets: AnswerPathTreeNode = {
  path: 'assets',
  children: [{ path: 'savingsAmount', nodeId: NodeIds.assetsSavings }],
};
